import { render, staticRenderFns } from "./VRequestObserver.vue?vue&type=template&id=04070faa"
import script from "./VRequestObserver.vue?vue&type=script&lang=js"
export * from "./VRequestObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports